import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      app_name: 'Interlink',
      tagline: 'Connect Your Business',
      login: 'Login',
      register: 'Register',
      phone: 'Phone Number',
      password: 'Password',
      shop_name: 'Shop Name',
      shop_type: 'Shop Type',
      location: 'Location',
      retail: 'Retail',
      wholesale: 'Wholesale',
      both: 'Both',
      dashboard: 'Dashboard',
      products: 'Products',
      stock: 'Stock',
      sales: 'Sales',
      expenses: 'Expenses',
      loans: 'Loans',
      reports: 'Reports',
      income_statement: 'Income Statement',
      balance_sheet: 'Balance Sheet',
      cashflow: 'Cash Flow',
      logout: 'Logout',
      add: 'Add',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      revenue: 'Revenue',
      profit: 'Profit',
      loss: 'Loss',
      total: 'Total',
      quantity: 'Quantity',
      price: 'Price',
      category: 'Category',
      unit: 'Unit',
      welcome: 'Welcome',
      no_data: 'No data available',
    }
  },
  sw: {
    translation: {
      app_name: 'Interlink',
      tagline: 'Unganisha Biashara Yako',
      login: 'Ingia',
      register: 'Jisajili',
      phone: 'Namba ya Simu',
      password: 'Nywila',
      shop_name: 'Jina la Duka',
      shop_type: 'Aina ya Duka',
      location: 'Mahali',
      retail: 'Rejareja',
      wholesale: 'Jumla',
      both: 'Zote',
      dashboard: 'Dashibodi',
      products: 'Bidhaa',
      stock: 'Hifadhi',
      sales: 'Mauzo',
      expenses: 'Gharama',
      loans: 'Mikopo',
      reports: 'Ripoti',
      income_statement: 'Taarifa ya Mapato',
      balance_sheet: 'Mizania',
      cashflow: 'Mtiririko wa Fedha',
      logout: 'Ondoka',
      add: 'Ongeza',
      cancel: 'Ghairi',
      save: 'Hifadhi',
      delete: 'Futa',
      revenue: 'Mapato',
      profit: 'Faida',
      loss: 'Hasara',
      total: 'Jumla',
      quantity: 'Kiasi',
      price: 'Bei',
      category: 'Aina',
      unit: 'Kipimo',
      welcome: 'Karibu',
      no_data: 'Hakuna taarifa',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'sw',
    interpolation: { escapeValue: false }
  });

export default i18n;
